import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);
export default {
    successMessage: (body, timer, title, persistent, settings) => {
        const hasQuizBanner = document.querySelector(".banner_1m_order_quiz");
        const hasCheckoutBanner = document.querySelector(".banner_1m_order_checkout");
        const data = {
            title,
            toast: true,
            text: body,
            padding: "10px",
            customClass: {
                htmlContainer: "toast-container toast-success-container",
                container: `toast-wrapper ${(hasCheckoutBanner || hasQuizBanner) && "toast-wrapper--banner"}`,
            },
            showClass: {
                popup: "toast toast__animated--show",
            },
            hideClass: {
                popup: "toast toast__animated--hide",
            },
            showConfirmButton: false,
            position: "top",
            background: "#60D179",
            backdrop: false,
            target: settings ? settings.target : "body",
            ...settings,
        };
        if (persistent) {
            data.showCloseButton = true;
        }
        else {
            data.timer = timer || 3000;
        }
        // @ts-ignore
        MySwal.fire(data);
    },
    errorMessage: (body, timer, title, persistent, settings) => {
        if (typeof body !== "string") {
            console.error("Error message must be a string. Instead, error message was ", body);
            return;
        }
        const hasQuizBanner = document.querySelector(".banner_1m_order_quiz");
        const hasCheckoutBanner = document.querySelector(".banner_1m_order_checkout");
        const data = {
            title,
            toast: true,
            text: body.replace(/"/g, ""),
            padding: "10px",
            customClass: {
                htmlContainer: "toast-container toast-error-container",
                container: `toast-wrapper ${(hasCheckoutBanner || hasQuizBanner) && "toast-wrapper--banner"}`,
            },
            showClass: {
                popup: "toast toast__animated--show",
            },
            hideClass: {
                popup: "toast toast__animated--hide",
            },
            showConfirmButton: false,
            position: "top",
            background: "#e6473d",
            backdrop: false,
            ...settings,
        };
        if (persistent) {
            data.showCloseButton = true;
        }
        else {
            data.timer = timer || 4500;
        }
        // @ts-ignore
        MySwal.fire(data);
    },
    handleError(error) {
        if (error.response && error.response.data) {
            const errorMessageStr = error.response.data;
            return this.errorMessage(errorMessageStr);
        }
        if (error) {
            try {
                if (typeof JSON.parse(error.message) === "object") {
                    if ("message" in JSON.parse(error.message)) {
                        if (JSON.parse(error.message).message !== "") {
                            return this.errorMessage(JSON.parse(error.message).message);
                        }
                    }
                }
                else {
                    return this.errorMessage(error.message);
                }
            }
            catch (e) {
                return this.errorMessage("Something went wrong.");
            }
        }
        else {
            return this.errorMessage("Something went wrong.");
        }
    },
};
